import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import JSBI from "jsbi";
import { SolidityType } from "../constants";
import { validateSolidityTypeInstance } from "../utils";
/**
 * A currency is any fungible financial instrument on Ethereum, including Ether and all ERC20 tokens.
 *
 * The only instance of the base class `Currency` is Ether.
 */ export var Currency = function Currency(decimals, symbol, name) {
    "use strict";
    _class_call_check(this, Currency);
    validateSolidityTypeInstance(JSBI.BigInt(decimals), SolidityType.uint8);
    this.decimals = decimals;
    this.symbol = symbol;
    this.name = name;
};
/**
   * The only instance of the base class `Currency`.
   */ Currency.BNB = new Currency(18, "BNB", "Binance Chain Native Token");
Currency.ETHER = new Currency(18, "ETH", "Ethereum Chain Native Token");
Currency.POLYGON = new Currency(18, "POL", "Polygon Chain Native Token");
Currency.BASE = new Currency(18, "ETH", "Base Chain Native Token");
Currency.ARB = new Currency(18, "ETH", "Base Chain Native Token");
Currency.DAN = new Currency(18, "DAN", "Dan Chain Native Token");
Currency.DANNY = new Currency(18, "DAN", "Danny Chain Native Token");
var ETHER = Currency.ETHER;
var BASE = Currency.BASE;
var POLYGON = Currency.POLYGON;
var BNB = Currency.BNB;
var ARB = Currency.ARB;
var DAN = Currency.DAN;
var DANNY = Currency.DANNY;
export { ETHER, BASE, POLYGON, BNB, ARB, DAN, DANNY };
